import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponse, Disposers, Plants, Role, SubPlants } from '../../api/dropdown';

@Injectable({
    providedIn: 'root'
})
export class ManageAccountService {
    private getAllEndpoint = environment.ECO_WASTE_SERVICE_URL + '/User/GetAll';
    private getUserEndpoint = environment.ECO_WASTE_SERVICE_URL + '/User/GetById';
    private createUserEndpoint = environment.ECO_WASTE_SERVICE_URL + '/User/Create';
    private updateUserEndpoint = environment.ECO_WASTE_SERVICE_URL + '/User/Update';
    private deleteUserEndpoint = environment.ECO_WASTE_SERVICE_URL + '/User/DeleteById';
    private getDropDownForUserEndpoint = environment.ECO_WASTE_SERVICE_URL + '/User/GetDropDownForUser';
    private changePasswordEndpoint = environment.ECO_WASTE_SERVICE_URL + '/User/ChangePassword';
    private changeOwnPasswordEndpoint = environment.ECO_WASTE_SERVICE_URL + '/User/ChangeOwnPassword';
    private changeOwnEmailEndpoint = environment.ECO_WASTE_SERVICE_URL + '/User/ChangeEmail';


    constructor(private http: HttpClient) { }

    getAll(): Observable<any[]> {
        return this.http.get<any[]>(this.getAllEndpoint);
    }

    getRoles(): Observable<Role[]> {
        return this.http.get<ApiResponse>(`${this.getDropDownForUserEndpoint}`).pipe(
            map(response => response.roles)
        );
    }

    getPlants(): Observable<Plants[]> {
        return this.http.get<ApiResponse>(`${this.getDropDownForUserEndpoint}`).pipe(
            map(response => response.plants)
        );
    }

    getSubPlants(): Observable<SubPlants[]> {
        return this.http.get<ApiResponse>(`${this.getDropDownForUserEndpoint}`).pipe(
            map(response => response.subplants)
        );
    }

    getDisposers(): Observable<Disposers[]> {
        return this.http.get<ApiResponse>(`${this.getDropDownForUserEndpoint}`).pipe(
            map(response => response.disposers)
        );
    }

    createUser(userData: any): Observable<any> {
        console.log("Service: ", userData)
        return this.http.post<any>(this.createUserEndpoint, userData);
    }

    getUserById(userId: number): Observable<any> {
        const url = `${this.getUserEndpoint}?userId=${userId}`;
        return this.http.get<any>(url)
            .pipe(
                catchError((error: any) => {
                    console.error('Error fetching user details:', error);
                    throw error;
                })
            );
    }

    updateUser(userData: any): Observable<any> {
        return this.http.put<any>(this.updateUserEndpoint, userData);
    }

    deleteUser(userId: number): Observable<any> {
        const url = `${this.deleteUserEndpoint}?id=${userId}`;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'accept': '*/*'
        });
        return this.http.put(url, {}, { headers: headers });
    }


    changePassword(passwordData:{id: number, password: string, confirmPassword: string}): Observable<any> {
        // const url = `${this.changePasswordEndpoint}?id=${passwordData.id}&password=${passwordData.password}&confirmPassword=${passwordData.confirmPassword}`;
        const queryParams = `id=${encodeURIComponent(passwordData.id.toString())}&oldPassword=${encodeURIComponent(passwordData.password)}&password=${encodeURIComponent(passwordData.password)}&confirmPassword=${encodeURIComponent(passwordData.confirmPassword)}`;
        const url = `${this.changePasswordEndpoint}?${queryParams}`;
        console.log(url)
        return this.http.put<any>(url, {}, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'accept': '*/*'
            })
        });
    }

    changeOwnPassword(passwordData:{id: number, oldPassword: string, password: string, confirmPassword: string}): Observable<any> {
        // const url = `${this.changeOwnPasswordEndpoint}?id=${passwordData.id}&oldPassword=${passwordData.oldPassword}&password=${passwordData.password}&confirmPassword=${passwordData.confirmPassword}`;
        const queryParams = `id=${encodeURIComponent(passwordData.id.toString())}&oldPassword=${encodeURIComponent(passwordData.oldPassword)}&password=${encodeURIComponent(passwordData.password)}&confirmPassword=${encodeURIComponent(passwordData.confirmPassword)}`;
        const url = `${this.changeOwnPasswordEndpoint}?${queryParams}`;
        console.log(url)
        return this.http.put<any>(url, {}, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'accept': '*/*'
            })
        });
    }

    changeEmail(userData:{id: number, email: string}): Observable<any> {
        const url = `${this.changeOwnEmailEndpoint}?id=${userData.id}&email=${userData.email}`;
        console.log(url)
        return this.http.put<any>(url, {}, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'accept': '*/*'
            })
        });
    }

}